<template>
    <v-navigation-drawer
        id="norfield-navigation-drawer"
        app
        color="#122448"
        dark
        permanent
        touchless
        :mini-variant.sync="navbarMini"
    >
        <v-list-item 
            class="text-center pa-2"
            @click.prevent="toggleNavDrawer"
        >
            <LocatorLogixLogo v-if="navbarMini" />
            <LocatorLogixLogoWhite v-else />
        </v-list-item>

        <OfflineNavDrawerContent v-if="offline" />
        <NavDrawerContent v-else />
    </v-navigation-drawer>
</template>

<script>
import NavDrawerContent from './NavDrawerContent';
import OfflineNavDrawerContent from './Offline/OfflineNavDrawerContent';
import LocatorLogixLogo from './CustomIcons/LocatorLogixLogo';
import LocatorLogixLogoWhite from './CustomIcons/LocatorLogixLogoWhite';
export default {
    components: {
        NavDrawerContent,
        OfflineNavDrawerContent,
        LocatorLogixLogo,
        LocatorLogixLogoWhite,
    },
    computed: {
        navbarMini() {
            return this.$store.getters.navbarMini;
        },
        offline() {
            return this.$store.getters.forceOffline;
        },
    },
    methods: {
        toggleNavDrawer() {
            this.$emit('toggle-navbar');
        },
    }
};
</script>
<style>
#norfield-navigation-drawer .v-list-item .app-title {
    font-size: 16pt;
}
</style>
